import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Input } from '@/components/ui/input';

import { View } from 'lucide-react';
import { ReactNode } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { PlannerConfigEntityWithOptionalFields } from '@/services/configurator/PlannerConfigTypes';

export type PlannerFormItemImageProps = {
  label?: ReactNode;
  description?: string;
  disabled?: boolean;
  field: ControllerRenderProps<
    PlannerConfigEntityWithOptionalFields,
    'imageUrl' | 'secondaryBannerImgUrl'
  >;
};

export function PlannerFormItemImage(props: PlannerFormItemImageProps) {
  return (
    <FormItem>
      <FormLabel>{props.label}</FormLabel>
      {props.field.value && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger onClick={(e) => e.preventDefault()}>
              <View className='ml-2 h-4 w-4' />
            </TooltipTrigger>
            <TooltipContent>
              <img src={props.field.value} className='w-[200px]' alt='' />
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      <FormControl>
        <Input {...props.field} disabled={props.disabled} />
      </FormControl>
      <FormDescription>{props.description}</FormDescription>
      <FormMessage />
    </FormItem>
  );
}
